import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

// Copiado de petrol-ng (C:\git\gitlab\petrol-ng\src\components\badge\badge.ts).
// Sin cambios respecto al original. Ver plan/plan-13-badge_testing_y_footer_login.md.

export type BadgeStatus = 'success' | 'warning' | 'danger' | 'info';

const BASE =
  'inline-flex items-center gap-1 rounded-none border px-2 py-0.5 text-[9px] font-bold uppercase leading-none tracking-wider';

const STATUS_VARIANT: Record<BadgeStatus, string> = {
  success:
    'border-success/30 bg-success/10 text-[#1e6b22] dark:border-success-dark/30 dark:bg-success-dark/10 dark:text-success-dark',
  warning:
    'border-warning/40 bg-warning/10 text-[#8a5a00] dark:border-warning-dark/30 dark:bg-warning-dark/10 dark:text-warning-dark',
  danger:
    'border-danger/30 bg-danger/10 text-danger dark:border-danger-dark/30 dark:bg-danger-dark/10 dark:text-danger-dark',
  info: 'border-info/40 bg-info/10 text-info dark:border-info-dark/30 dark:bg-info-dark/10 dark:text-info-dark',
};

/**
 * Badge de estado (success/warning/danger/info): texto de color sobre fondo
 * tintado al 10% del mismo color.
 */
@Component({
  selector: 'petrol-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './badge.component.html',
})
export class PetrolBadgeComponent {
  readonly status = input<BadgeStatus>('info');

  protected readonly classes = computed(() => `${BASE} ${STATUS_VARIANT[this.status()]}`);
}
